angular
	.module 'App.Module.Journal', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'journal',
				url: '/journal',
				views:
					"main":
						controller: 'JournalController'
						controllerAs: 'vm'
						templateUrl: '@app/journal/journal.view.html'
				data:
					restrict: 'POS.Core.JournalService.Enabled'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					shops: (JournalServiceRepository) ->
						return JournalServiceRepository.listShops()
					registers: (JournalServiceRepository) ->
						return JournalServiceRepository.listRegisters()
